// redux/chatSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API_AGENTS_CHAT_DELETE, API_AGENTS_CHAT_MIGRATE } from '../api/chatSetting.service';

// Async Thunks for API calls
export const deleteAgentMessage = createAsyncThunk(
  'chat/deleteAgentMessage',
  async (data, thunkAPI) => {
    try {
      const response = await API_AGENTS_CHAT_DELETE(data);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const migrateAgentChatGroups = createAsyncThunk(
  'chat/migrateAgentChatGroups',
  async (data, thunkAPI) => {
    try {
      const response = await API_AGENTS_CHAT_MIGRATE(data);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Slice definition
const chatSlice = createSlice({
  name: 'chat',
  initialState: {
    messages: [],
    migrationStatus: null,
    loading: false,
    error: null,
  },
  reducers: {
    resetChatState: (state) => {
      state.messages = [];
      state.migrationStatus = null;
      state.error = null;
    },
  },
});

// Export actions and reducers
export const { resetChatState } = chatSlice.actions;
export default chatSlice.reducer;
